import { Box } from '@chakra-ui/react';
import { GoalsTable } from '@devd-client/devd/components';
import { useLocation } from 'react-router-dom';

export const TeamGoals = () => {
  const { pathname } = useLocation();

  return (
    <Box>
      <GoalsTable
        scope="TEAM"
        teamId={decodeURIComponent(pathname.split('/')[2])}
      />
    </Box>
  );
};
